// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Simple tag input with pill styling */
.tag-input {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border: 1px solid var(--input-border);
  padding: 4px 6px;
  border-radius: 6px;
  min-height: 36px;
  background: var(--input-bg);
  cursor: text;
  color: var(--text-tertiary);
}

.tag-input input {
  border: none;
  flex: 1 1;
  min-width: 100px;
  padding: 4px;
  font-size: 0.95rem;
  background: transparent;
  color: var(--input-text);
  outline: none;
}

.tag-input .tag-pill {
  display: flex;
  align-items: center;
  background: var(--accent-secondary);
  color: white;
  padding: 2px 8px;
  margin: 2px;
  border-radius: 12px;
  font-size: 0.85rem;
}

.tag-input .tag-pill.overtags {
  background: var(--error-bg);
}

.tag-input .tag-pill .remove {
  margin-left: 4px;
  cursor: pointer;
  font-weight: bold;
}

.tag-input-overtags-warning {
  margin: 4px 2px 0;
  font-size: 0.8rem;
  color: var(--error-text, var(--error-color));
}
`, "",{"version":3,"sources":["webpack://./src/components/TagInput/TagInput.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,4CAA4C;AAC9C","sourcesContent":["/* Simple tag input with pill styling */\r\n.tag-input {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  border: 1px solid var(--input-border);\r\n  padding: 4px 6px;\r\n  border-radius: 6px;\r\n  min-height: 36px;\r\n  background: var(--input-bg);\r\n  cursor: text;\r\n  color: var(--text-tertiary);\r\n}\r\n\r\n.tag-input input {\r\n  border: none;\r\n  flex: 1;\r\n  min-width: 100px;\r\n  padding: 4px;\r\n  font-size: 0.95rem;\r\n  background: transparent;\r\n  color: var(--input-text);\r\n  outline: none;\r\n}\r\n\r\n.tag-input .tag-pill {\r\n  display: flex;\r\n  align-items: center;\r\n  background: var(--accent-secondary);\r\n  color: white;\r\n  padding: 2px 8px;\r\n  margin: 2px;\r\n  border-radius: 12px;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.tag-input .tag-pill.overtags {\r\n  background: var(--error-bg);\r\n}\r\n\r\n.tag-input .tag-pill .remove {\r\n  margin-left: 4px;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n}\r\n\r\n.tag-input-overtags-warning {\r\n  margin: 4px 2px 0;\r\n  font-size: 0.8rem;\r\n  color: var(--error-text, var(--error-color));\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
